<app-dialog-header [title]="'RETRY_SAVING.DIALOG.TITLE.CANT_SAVE_RIGHT_NOW'" (onClick)="dialogRef.close(false)"></app-dialog-header>

<div mat-dialog-content class="p-24 pb-0">
    <p class="my-0">{{ label | translate }}</p>
</div>

<div mat-dialog-actions class="pt-24 action-buttons" fxLayout="row" fxLayoutAlign="end center">
    <app-flat-button [label]="'RETRY_SAVING.BUTTON.RETRY_SAVING'" (onClick)="save.emit()" [autofocus]="true"></app-flat-button>
</div>
